/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `port` - Port
* `factory` - Factory
* `warehouse` - Warehouse
* `distribution_centre` - Distribution centre
* `transport_hub` - Transport hub
* `depot` - Depot
* `retail_store` - Retail store
* `restaurant` - Restaurant
* `central_kitchen` - Central kitchen
* `consumer_home` - Consumer home
 */
export type NodeTypeEnum = typeof NodeTypeEnum[keyof typeof NodeTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NodeTypeEnum = {
  port: 'port',
  factory: 'factory',
  warehouse: 'warehouse',
  distribution_centre: 'distribution_centre',
  transport_hub: 'transport_hub',
  depot: 'depot',
  retail_store: 'retail_store',
  restaurant: 'restaurant',
  central_kitchen: 'central_kitchen',
  consumer_home: 'consumer_home',
} as const;
